import { Contextualized } from './types/userTypes';

export const canEdit = ({ userContext }: Contextualized) =>
	userContext.permissions.edit;
